import APP_CONSTANTS from "src/application/shared/app_constants";
import loadCensoredWords from "../loadCensoredWords";

let censored_words_en = new Set([
  "3p",
  "g スポット",
  "s ＆ m",
  "sm",
  "sm女王",
  "xx",
  "アジアのかわいい女の子",
  "アスホール",
  "アナリングス",
  "アナル",
  "いたずら",
  "イラマチオ",
  "エクスタシー",
  "エスコート",
  "エッチ",
  "エロティズム",
  "エロティック",
  "オーガズム",
  "オカマ",
  "おしっこ",
  "おしり",
  "オシリ",
  "おしりのあな",
  "おっぱい",
  "オッパイ",
  "オナニー",
  "オマンコ",
  "おもらし",
  "お尻",
  "カーマスートラ",
  "カント",
  "クリトリス",
  "グループ・セックス",
  "グロ",
  "クンニリングス",
  "ゲイ・セックス",
  "ゲイボーイ",
  "ゴールデンシャワー",
  "コカイン",
  "ゴックン",
  "サディズム",
  "しばり",
  "スウィンガー",
  "スカートの中",
  "スカトロ",
  "ストラップオン",
  "ストリップ劇場",
  "スラット",
  "スリット",
  "セクシーな",
  "セクシーな 10 代",
  "セックス",
  "ソドミー",
  "ちんこ",
  "ディープ・スロート",
  "ディック",
  "ディルド",
  "デートレイプ",
  "デブ",
  "テレフォンセックス",
  "ドッグスタイル",
  "トップレス",
  "なめ",
  "ニガー",
  "ヌード",
  "ネオ・ナチ",
  "ハードコア",
  "パイパン",
  "バイブレーター",
  "バック・スタイル",
  "パンティー",
  "ビッチ",
  "ファック",
  "ファンタジー",
  "フィスト",
  "フェティッシュ",
  "フェラチオ",
  "ふたなり",
  "ぶっかけ",
  "フック",
  "プリンス アルバート ピアス",
  "プレイボーイ",
  "ベアバック",
  "ペニス",
  "ペニスバンド",
  "ボーイズラブ",
  "ボールギャグ",
  "ぽっちゃり",
  "ホモ",
  "ポルノ",
  "ポルノグラフィー",
  "ボンテージ",
  "マザー・ファッカー",
  "マスターベーション",
  "まんこ",
  "やおい",
  "やりまん",
  "ラティーナ",
  "ラバー",
  "ランジェリー",
  "レイプ",
  "レズビアン",
  "ローター",
  "ロリータ",
  "淫乱",
  "陰毛",
  "革抑制",
  "騎上位",
  "巨根",
  "巨乳",
  "強姦犯",
  "玉なめ",
  "玉舐め",
  "緊縛",
  "近親相姦",
  "嫌い",
  "後背位",
  "合意の性交",
  "拷問",
  "殺し方",
  "殺人事件",
  "殺人方法",
  "支配",
  "児童性虐待",
  "自己愛性",
  "射精",
  "手コキ",
  "獣姦",
  "女の子",
  "女王様",
  "女子高生",
  "女装",
  "新しいポルノ",
  "人妻",
  "人種",
  "性交",
  "正常位",
  "生殖器",
  "精液",
  "挿入",
  "足フェチ",
  "足を広げる",
  "大陰唇",
  "脱衣",
  "茶色のシャワー",
  "中出し",
  "潮吹き女",
  "潮吹き男性",
  "直腸",
  "剃毛",
  "貞操帯",
  "奴隷",
  "二穴",
  "乳首",
  "尿道プレイ",
  "覗き",
  "売春婦",
  "縛り",
  "噴出",
  "糞",
  "糞尿愛好症",
  "糞便",
  "平手打ち",
  "変態",
  "勃起する",
  "夢精",
  "毛深い",
  "誘惑",
  "幼児性愛者",
  "裸",
  "裸の女性",
  "乱交",
  "両性",
  "両性具有",
  "両刀",
  "輪姦",
  "卍",
  "宦官",
  "肛門",
  "膣",
]);

if (!censored_words_en.keys.length) {
  async () => {
    try {
      censored_words_en = await loadCensoredWords(
        APP_CONSTANTS.CENSORED_WORDS_FETCH_URLS.JA
      );
    } catch (error) {
      throw new Error(`❌ Error loading censored words [JA]! ${error}`);
    }
  };
}

export default censored_words_en;
